import React from 'react'
import styled from 'styled-components'

import { CellNumberCmp, CellSize, CellStatus, ICellResult } from '../types/common'
import arrowImg from '../assets/images/arrow.png'

interface IProps {
  selectedPlayer: { firstName: string; lastName: string; cells: ICellResult[] }
}

export default function ResultRow({ selectedPlayer }: IProps) {
  const { firstName, lastName, cells } = selectedPlayer

  console.log(cells)

  return (
    <Container>
      <p>{`${firstName} ${lastName}`}</p>
      {cells.map((cell, index) => (
        <CellContainer key={index} numberCmp={cell.numberCmp} size={cell.size} status={cell.status}>
          {(cell.numberCmp === CellNumberCmp.HIGHER || cell.numberCmp === CellNumberCmp.LOWER) && (
            <img alt="" src={arrowImg} />
          )}
          <div>
            {cell.value && <p>{cell.value}</p>}
            {cell.logos && cell.logos.map((logo) => <img alt="" className="logo" src={logo} />)}
          </div>
        </CellContainer>
      ))}
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 104px;
  justify-content: flex-start;
  width: 100%;

  & > p {
    flex-shrink: 0;
    font-size: 14px;
    text-align: center;
    width: 160px;
  }
`

const CellContainer = styled.div<{ size: CellSize; status: CellStatus; numberCmp?: CellNumberCmp }>`
  align-items: center;
  border: ${({ theme }) => `solid 1px ${theme.palette.text}`};
  background-color: ${({ status, theme }) => {
    if (status === CellStatus.PARTIAL) return theme.palette.warning
    if (status === CellStatus.ERROR) return theme.palette.error

    return theme.palette.valid
  }};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  position: relative;
  height: 100%;
  width: ${({ size }) => {
    if (size === CellSize.LARGE) return '240px'
    if (size === CellSize.MEDIUM) return '160px'

    return '96px'
  }};

  & > img {
    height: 88px;
    transform: ${({ numberCmp }) => (numberCmp === CellNumberCmp.HIGHER ? 'rotate(180deg)' : 'none')};
    width: auto;
  }

  & > div {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 100%;
    justify-content: center;
    gap: 4px;
    left: 0;
    padding: 8px;
    position: absolute;
    top: 0;
    width: 100%;

    & > p {
      font-size: 14px;
      text-align: center;
    }

    & > img {
      height: auto;
      width: 32px;
    }
  }
`
